// Mock data for BIM and LiDAR services website

export const services = [
  {
    id: '1',
    title: '3D Laser Scanning & Point Cloud Services',
    title_es: 'Escaneo Láser 3D y Servicios de Nube de Puntos',
    description: 'Industry-leading LiDAR technology capturing millions of data points to create highly accurate 3D point clouds for comprehensive site documentation and analysis.',
    description_es: 'Tecnología LiDAR líder en la industria que captura millones de puntos de datos para crear nubes de puntos 3D altamente precisas para documentación y análisis integral del sitio.',
    icon: 'Scan',
    features: ['High-Precision LiDAR Scanning', 'Point Cloud Processing', 'Data Registration', 'Quality Assurance'],
    features_es: ['Escaneo LiDAR de Alta Precisión', 'Procesamiento de Nube de Puntos', 'Registro de Datos', 'Control de Calidad'],
    featured: true
  },
  {
    id: '2',
    title: 'As-Built BIM Modeling',
    title_es: 'Modelado BIM As-Built',
    description: 'Transform point cloud data into intelligent BIM models that accurately represent existing conditions for renovation, retrofit, and facility management projects.',
    description_es: 'Transforme datos de nube de puntos en modelos BIM inteligentes que representan con precisión las condiciones existentes para proyectos de renovación, modernización y gestión de instalaciones.',
    icon: 'Box',
    features: ['Point Cloud to BIM', 'LOD 100-500 Modeling', 'Existing Conditions Documentation', 'Clash Detection'],
    features_es: ['Nube de Puntos a BIM', 'Modelado LOD 100-500', 'Documentación de Condiciones Existentes', 'Detección de Conflictos']
  },
  {
    id: '3',
    title: 'LiDAR Mapping',
    title_es: 'Mapeo LiDAR',
    description: 'Advanced LiDAR mapping services for topographic surveys, infrastructure planning, and large-scale site analysis with centimeter-level accuracy.',
    description_es: 'Servicios avanzados de mapeo LiDAR para levantamientos topográficos, planificación de infraestructura y análisis de sitios a gran escala con precisión centimétrica.',
    icon: 'Map',
    features: ['Topographic Mapping', 'Terrain Modeling', 'Contour Generation', 'Volume Calculations'],
    features_es: ['Mapeo Topográfico', 'Modelado de Terreno', 'Generación de Curvas de Nivel', 'Cálculos de Volumen']
  },
  {
    id: '4',
    title: 'Virtual Tours & 3D Visualization',
    title_es: 'Tours Virtuales y Visualización 3D',
    description: 'Immersive 360° virtual tours and interactive 3D visualizations enabling remote site inspection and stakeholder collaboration.',
    description_es: 'Tours virtuales inmersivos de 360° y visualizaciones 3D interactivas que permiten inspección remota del sitio y colaboración con partes interesadas.',
    icon: 'Eye',
    features: ['360° Virtual Tours', 'Interactive Walkthroughs', 'Remote Access', 'Stakeholder Presentations'],
    features_es: ['Tours Virtuales 360°', 'Recorridos Interactivos', 'Acceso Remoto', 'Presentaciones a Partes Interesadas']
  },
  {
    id: '5',
    title: '2D CAD Drawings',
    title_es: 'Planos CAD 2D',
    description: 'Precise 2D CAD drawings extracted from point cloud data including floor plans, elevations, sections, and reflected ceiling plans.',
    description_es: 'Planos CAD 2D precisos extraídos de datos de nube de puntos, incluyendo planos de planta, elevaciones, secciones y planos de techo reflejado.',
    icon: 'FileText',
    features: ['Floor Plans', 'Elevations & Sections', 'Detail Drawings', 'Construction Documents'],
    features_es: ['Planos de Planta', 'Elevaciones y Secciones', 'Dibujos de Detalle', 'Documentos de Construcción']
  },
  {
    id: '6',
    title: 'Scan to CAD Services',
    title_es: 'Servicios de Escaneo a CAD',
    description: 'Comprehensive scan-to-CAD conversion services transforming raw scan data into clean, accurate CAD drawings for design and construction.',
    description_es: 'Servicios integrales de conversión escaneo-a-CAD que transforman datos brutos de escaneo en dibujos CAD limpios y precisos para diseño y construcción.',
    icon: 'Layers',
    features: ['Point Cloud to CAD', 'As-Built Drawings', 'MEP Documentation', 'Dimensional Accuracy'],
    features_es: ['Nube de Puntos a CAD', 'Dibujos As-Built', 'Documentación MEP', 'Precisión Dimensional']
  },
  {
    id: '7',
    title: 'Architectural Scanning',
    title_es: 'Escaneo Arquitectónico',
    description: 'Specialized architectural scanning for heritage preservation, facade documentation, and detailed building surveys capturing intricate design elements.',
    description_es: 'Escaneo arquitectónico especializado para preservación del patrimonio, documentación de fachadas y levantamientos detallados de edificios capturando elementos de diseño intrincados.',
    icon: 'Building2',
    features: ['Heritage Documentation', 'Facade Scanning', 'Ornamental Details', 'Preservation Planning'],
    features_es: ['Documentación Patrimonial', 'Escaneo de Fachadas', 'Detalles Ornamentales', 'Planificación de Preservación']
  },
  {
    id: '8',
    title: '3D Rendering & Plan Visualizations',
    title_es: 'Renderizado 3D y Visualizaciones de Planos',
    description: 'Photorealistic 3D renderings and plan visualizations that bring your designs to life for real estate developers, homeowners, and contractors.',
    description_es: 'Renderizados 3D fotorrealistas y visualizaciones de planos que dan vida a sus diseños para desarrolladores inmobiliarios, propietarios y contratistas.',
    icon: 'Image',
    features: ['Photorealistic Renderings', 'Interactive 3D Models', 'Marketing Visualizations', 'Design Presentations'],
    features_es: ['Renderizados Fotorrealistas', 'Modelos 3D Interactivos', 'Visualizaciones de Marketing', 'Presentaciones de Diseño'],
    featured: true
  },
  {
    id: '9',
    title: 'Digital Twin Creation',
    title_es: 'Creación de Gemelos Digitales',
    description: 'Comprehensive digital replicas of physical assets enabling real-time monitoring, predictive maintenance, and lifecycle management for facilities.',
    description_es: 'Réplicas digitales integrales de activos físicos que permiten monitoreo en tiempo real, mantenimiento predictivo y gestión del ciclo de vida de instalaciones.',
    icon: 'Copy',
    features: ['Real-Time Asset Monitoring', 'Facility Management', 'IoT Integration', 'Lifecycle Analysis'],
    features_es: ['Monitoreo de Activos en Tiempo Real', 'Gestión de Instalaciones', 'Integración IoT', 'Análisis del Ciclo de Vida'],
    featured: true
  },
  {
    id: '10',
    title: 'BIM Coordination & Clash Detection',
    title_es: 'Coordinación BIM y Detección de Conflictos',
    description: 'Advanced BIM coordination services ensuring all building systems work together seamlessly, identifying and resolving conflicts before construction.',
    description_es: 'Servicios avanzados de coordinación BIM que aseguran que todos los sistemas del edificio funcionen juntos sin problemas, identificando y resolviendo conflictos antes de la construcción.',
    icon: 'Network',
    features: ['Multi-Discipline Coordination', 'Clash Detection', 'Issue Resolution', 'Model Management'],
    features_es: ['Coordinación Multi-Disciplinaria', 'Detección de Conflictos', 'Resolución de Problemas', 'Gestión de Modelos']
  },
  {
    id: '11',
    title: 'Managed IT Services',
    title_es: 'Servicios IT Administrados',
    description: 'Comprehensive IT solutions tailored for trades and Hispanic-owned businesses — from network setup and cybersecurity to cloud migration and ongoing tech support that keeps your operations running smoothly.',
    description_es: 'Soluciones IT integrales diseñadas para negocios de oficios y empresas hispanas — desde configuración de redes y ciberseguridad hasta migración a la nube y soporte técnico continuo que mantiene sus operaciones funcionando sin problemas.',
    icon: 'Monitor',
    features: ['Network & Infrastructure Setup', 'Cybersecurity & Data Protection', 'Cloud Solutions & Migration', '24/7 Technical Support'],
    features_es: ['Configuración de Redes e Infraestructura', 'Ciberseguridad y Protección de Datos', 'Soluciones en la Nube y Migración', 'Soporte Técnico 24/7']
  },
  {
    id: '12',
    title: 'Cybersecurity & Data Protection',
    title_es: 'Ciberseguridad y Protección de Datos',
    description: 'Comprehensive cybersecurity solutions safeguarding your business data, networks, and digital assets — from threat detection and incident response to compliance auditing and employee security training for trades and Hispanic-owned businesses.',
    description_es: 'Soluciones integrales de ciberseguridad que protegen los datos, redes y activos digitales de su negocio — desde detección de amenazas y respuesta a incidentes hasta auditorías de cumplimiento y capacitación en seguridad para negocios de oficios y empresas hispanas.',
    icon: 'ShieldCheck',
    features: ['Threat Detection & Prevention', 'Data Encryption & Backup', 'Compliance Auditing', 'Security Awareness Training'],
    features_es: ['Detección y Prevención de Amenazas', 'Cifrado y Respaldo de Datos', 'Auditoría de Cumplimiento', 'Capacitación en Seguridad']
  }
];

export const industries = [
  {
    id: '1',
    name: 'Construction',
    name_es: 'Construcción',
    description: 'Improved planning, reduced rework, accurate as-builts, and enhanced site coordination for construction projects of all scales.',
    description_es: 'Planificación mejorada, menos retrabajos, as-builts precisos y coordinación mejorada del sitio para proyectos de construcción de todas las escalas.',
    image: 'https://customer-assets.emergentagent.com/job_bimlidar-experts/artifacts/6xkw00t8_CONSTRUCTION.jpg',
    benefits: [
      'Enhanced Project Planning',
      'Minimized Rework & Changes',
      'Accurate As-Built Documentation',
      'Improved Stakeholder Coordination',
      'Reduced Construction Timeline'
    ],
    benefits_es: [
      'Planificación de Proyecto Mejorada',
      'Retrabajos y Cambios Minimizados',
      'Documentación As-Built Precisa',
      'Coordinación Mejorada de Partes Interesadas',
      'Cronograma de Construcción Reducido'
    ]
  },
  {
    id: '2',
    name: 'Real Estate',
    name_es: 'Inmobiliaria',
    description: 'Reliable property documentation, asset evaluation, renovation planning, and transaction support for real estate professionals.',
    description_es: 'Documentación confiable de propiedades, evaluación de activos, planificación de renovaciones y soporte de transacciones para profesionales inmobiliarios.',
    image: 'https://customer-assets.emergentagent.com/job_bimlidar-experts/artifacts/atjmoi3n_REAL%20ESTATE%20B.avif',
    benefits: [
      'Comprehensive Property Documentation',
      'Accurate Asset Valuation',
      'Renovation & Retrofit Planning',
      'Due Diligence Support',
      'Portfolio Management'
    ],
    benefits_es: [
      'Documentación Integral de Propiedades',
      'Valuación Precisa de Activos',
      'Planificación de Renovación y Modernización',
      'Soporte de Debida Diligencia',
      'Gestión de Portafolio'
    ]
  }
];

export const projects = [
  {
    id: '1',
    title: 'Commercial Office Complex',
    category: 'Construction',
    description: 'Full BIM coordination and clash detection for 500,000 sq ft office development',
    metrics: { timeline: '18 months', clashes: '347 resolved', savings: '$2.4M' }
  },
  {
    id: '2',
    title: 'Healthcare Facility Renovation',
    category: 'Real Estate',
    description: 'LiDAR scanning and as-built documentation for hospital expansion project',
    metrics: { area: '200,000 sq ft', accuracy: '±3mm', duration: '4 weeks' }
  }
];

export const testimonials = [
  {
    id: '1',
    name: 'John Martinez',
    role: 'Project Manager',
    company: 'BuildTech Construction',
    content: 'Their BIM coordination services saved us millions in potential rework. The clash detection identified over 300 conflicts before we broke ground.',
    rating: 5
  },
  {
    id: '2',
    name: 'Sarah Chen',
    role: 'VP of Operations',
    company: 'Premier Real Estate Group',
    content: 'The LiDAR scanning and digital twin services provided unprecedented accuracy for our property assessments. Game-changing technology.',
    rating: 5
  }
];

export const teamMembers = [
  {
    id: '1',
    name: 'Sergio Ibarra',
    role: 'Founder & CEO',
    role_es: 'Fundador y CEO',
    bio: '20+ years in AEC industry, pioneering BIM implementation',
    bio_es: 'Más de 20 años en la industria AEC, pionero en implementación BIM'
  },
  {
    id: '2',
    name: 'Erick Ibarra',
    role: 'Director of Technology',
    role_es: 'Director de Tecnología',
    bio: 'Enterprise IT Infrastructure & Cybersecurity Solutions Expert',
    bio_es: 'Experto en Infraestructura IT Empresarial y Soluciones de Ciberseguridad'
  },
  {
    id: '3',
    name: 'Aleida Villatoro',
    role: 'Sales Representative',
    role_es: 'Representante de Ventas',
    bio: 'Driving growth in IT infrastructure, cybersecurity, and LiDAR services',
    bio_es: 'Impulsando el crecimiento en infraestructura IT, ciberseguridad y servicios LiDAR'
  }
];

export const stats = [];

export const contactInfo = {
  email: 'info@delta3dscan.com',
  phone: '+1 (616) 405-0194',
  address: '123 Innovation Drive, Tech City, TC 12345',
  hours: 'Monday - Friday: 9:00 AM - 5:00 PM',
  hours_es: 'Lunes - Viernes: 9:00 AM - 5:00 PM'
};

// Helper to get localized field
export const localize = (item, field, lang) => {
  if (lang === 'es' && item[`${field}_es`]) {
    return item[`${field}_es`];
  }
  return item[field];
};
